import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "redText" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_grid_default_render_cell = _resolveComponent("grid-default-render-cell")!
  const _component_date_field = _resolveComponent("date-field")!
  const _component_bool_field = _resolveComponent("bool-field")!
  const _component_grid_column_menu_checkbox_filter = _resolveComponent("grid-column-menu-checkbox-filter")!
  const _component_k_grid = _resolveComponent("k-grid")!
  const _component_loader_guard = _resolveComponent("loader-guard")!

  return (_openBlock(), _createBlock(_component_loader_guard, {
    hasLoaded: _ctx.hasLoaded,
    class: "my-grid"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_k_grid, {
        class: _normalizeClass([ _ctx.withHover ? '' : 'NoRowHover']),
        "cell-render": "defaultTemplate",
        "data-items": _ctx.gridData,
        columns: _ctx.columns,
        sortable: _ctx.sortable,
        reorderable: _ctx.reorderable,
        resizable: _ctx.resizable,
        filterable: _ctx.filterable,
        groupable: _ctx.groupable,
        pageable: _ctx.pageable,
        group: _ctx.gridState.group,
        filter: _ctx.gridState.filter,
        skip: _ctx.gridState.skip,
        take: _ctx.gridState.take,
        sort: _ctx.gridState.sort,
        "expand-field": "expanded",
        onPagechange: _ctx.onPageChange,
        onDatastatechange: _ctx.dataStateChange,
        onExpandchange: _ctx.expandChange,
        scrollable: "scrollable",
        style: {"max-height":"100%"}
      }, {
        defaultTemplate: _withCtx(({props}) => [
          _createVNode(_component_grid_default_render_cell, {
            cellProps: props,
            columns: _ctx.columns,
            onClick: ($event: any) => (_ctx.cellClick(props.dataItem))
          }, null, 8, ["cellProps", "columns", "onClick"])
        ]),
        dateTime: _withCtx(({props}) => [
          (_ctx.isNotGroupHeader(props))
            ? (_openBlock(), _createElementBlock("td", {
                key: 0,
                class: _normalizeClass(props.className)
              }, [
                _createVNode(_component_date_field, {
                  value: props.dataItem[props.field],
                  format: "datetime"
                }, null, 8, ["value"])
              ], 2))
            : _createCommentVNode("", true)
        ]),
        date: _withCtx(({props}) => [
          (_ctx.isNotGroupHeader(props))
            ? (_openBlock(), _createElementBlock("td", {
                key: 0,
                class: _normalizeClass(props.className)
              }, [
                _createVNode(_component_date_field, {
                  value: props.dataItem[props.field],
                  format: "date"
                }, null, 8, ["value"])
              ], 2))
            : _createCommentVNode("", true)
        ]),
        time: _withCtx(({props}) => [
          (_ctx.isNotGroupHeader(props))
            ? (_openBlock(), _createElementBlock("td", {
                key: 0,
                class: _normalizeClass(props.className)
              }, [
                _createVNode(_component_date_field, {
                  value: props.dataItem[props.field],
                  format: "time"
                }, null, 8, ["value"])
              ], 2))
            : _createCommentVNode("", true)
        ]),
        coloredYesNo: _withCtx(({props}) => [
          (_ctx.isNotGroupHeader(props))
            ? (_openBlock(), _createElementBlock("td", {
                key: 0,
                class: _normalizeClass(props.className)
              }, [
                _createVNode(_component_bool_field, {
                  value: props.dataItem[props.field],
                  format: "coloredYesNo"
                }, null, 8, ["value"])
              ], 2))
            : _createCommentVNode("", true)
        ]),
        yesNo: _withCtx(({props}) => [
          (_ctx.isNotGroupHeader(props))
            ? (_openBlock(), _createElementBlock("td", {
                key: 0,
                class: _normalizeClass(props.className)
              }, [
                _createVNode(_component_bool_field, {
                  value: props.dataItem[props.field],
                  format: "yesNo"
                }, null, 8, ["value"])
              ], 2))
            : _createCommentVNode("", true)
        ]),
        bool: _withCtx(({props}) => [
          (_ctx.isNotGroupHeader(props))
            ? (_openBlock(), _createElementBlock("td", {
                key: 0,
                class: _normalizeClass(props.className)
              }, [
                _createVNode(_component_bool_field, {
                  value: props.dataItem[props.field],
                  format: "X"
                }, null, 8, ["value"])
              ], 2))
            : _createCommentVNode("", true)
        ]),
        rightJustified: _withCtx(({props}) => [
          _createElementVNode("td", {
            class: _normalizeClass(props.className),
            style: {"text-align":"right"}
          }, _toDisplayString(props.dataItem[props.field]), 3)
        ]),
        custom1: _withCtx(({props}) => [
          _createElementVNode("td", {
            class: _normalizeClass(props.className)
          }, [
            _renderSlot(_ctx.$slots, "customTemplate1", { props: props })
          ], 2)
        ]),
        custom2: _withCtx(({props}) => [
          _createElementVNode("td", {
            class: _normalizeClass(props.className)
          }, [
            _renderSlot(_ctx.$slots, "customTemplate2", { props: props })
          ], 2)
        ]),
        custom3: _withCtx(({props}) => [
          _createElementVNode("td", {
            class: _normalizeClass(props.className)
          }, [
            _renderSlot(_ctx.$slots, "customTemplate3", { props: props })
          ], 2)
        ]),
        custom4: _withCtx(({props}) => [
          _createElementVNode("td", {
            class: _normalizeClass(props.className)
          }, [
            _renderSlot(_ctx.$slots, "customTemplate4", { props: props })
          ], 2)
        ]),
        activeFilterTemplate: _withCtx(({props}) => [
          _createElementVNode("span", _hoisted_1, _toDisplayString(props.title), 1)
        ]),
        checkboxFilter: _withCtx(({ props }) => [
          _createVNode(_component_grid_column_menu_checkbox_filter, {
            column: props.column,
            filter: props.filter,
            onFilterchange: ($event: any) => (_ctx.onCheckboxFilterChange(props, $event)),
            expanded: true,
            "data-items": _ctx.data ?? []
          }, null, 8, ["column", "filter", "onFilterchange", "data-items"])
        ]),
        _: 3
      }, 8, ["class", "data-items", "columns", "sortable", "reorderable", "resizable", "filterable", "groupable", "pageable", "group", "filter", "skip", "take", "sort", "onPagechange", "onDatastatechange", "onExpandchange"])
    ]),
    _: 3
  }, 8, ["hasLoaded"]))
}